<template functional>
  <el-tag v-if="props.row[props.column] === true" type="success">✔</el-tag>
  <el-tag v-else type="danger">✘</el-tag>
</template>

<script>
export default {
  name: "RenderCheckLabelRequired"
};
</script>
